"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullTabsMenu = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _index = require("../../molecules/TabsMenu/index");

var _index2 = require("../../molecules/StatusAsignationInfo/index");

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var FullTabsMenu = function FullTabsMenu(_ref) {
  var tabsSections = _ref.tabsSections,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? "" : _ref$status,
      activeTab = _ref.activeTab,
      setActiveTab = _ref.setActiveTab,
      setImageLayout = _ref.setImageLayout,
      assig = _ref.assig,
      setAssignation = _ref.setAssignation,
      isRetailer = _ref.isRetailer,
      downloadImages = _ref.downloadImages,
      askToDeleteImages = _ref.askToDeleteImages,
      onClickSave = _ref.onClickSave,
      showSaveButton = _ref.showSaveButton,
      canAssign = _ref.canAssign,
      version = _ref.version,
      setShowVersionSelector = _ref.setShowVersionSelector,
      images = _ref.images,
      updatedDescriptions = _ref.updatedDescriptions,
      updatedDatasheets = _ref.updatedDatasheets,
      selectedImages = _ref.selectedImages,
      setSelectedImages = _ref.setSelectedImages,
      setUpdatedDescriptions = _ref.setUpdatedDescriptions,
      setUpdatedDatasheets = _ref.setUpdatedDatasheets,
      setImages = _ref.setImages,
      user = _ref.user;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      imagesSection = _useState2[0],
      setImagesSection = _useState2[1];

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.TabsMenu, {
      tabsSections: tabsSections,
      setImagesSection: setImagesSection,
      setActiveTab: setActiveTab,
      activeTab: activeTab,
      images: images,
      updatedDescriptions: updatedDescriptions,
      updatedDatasheets: updatedDatasheets,
      selectedImages: selectedImages,
      setUpdatedDescriptions: setUpdatedDescriptions,
      setUpdatedDatasheets: setUpdatedDatasheets,
      setImages: setImages,
      setSelectedImages: setSelectedImages
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_index2.StatusAsignationInfo, {
      canAssign: canAssign,
      status: status,
      activeTab: activeTab,
      setImageLayout: setImageLayout,
      imagesSection: imagesSection,
      assignationsImages: assig,
      setAssignation: setAssignation,
      isRetailer: isRetailer,
      downloadImages: downloadImages,
      onClickSave: onClickSave,
      askToDeleteImages: askToDeleteImages,
      showSaveButton: showSaveButton,
      version: version,
      setShowVersionSelector: setShowVersionSelector,
      user: user
    })]
  });
};

exports.FullTabsMenu = FullTabsMenu;